import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./ServiceBlock.module.scss";

interface Service {
  id: string;
  title: string;
  description: string;
}

const ServiceBlock: React.FC = () => {
  const { t } = useTranslation("common");
  const services = t("serviceBlock.services", {
    returnObjects: true,
  }) as Service[];

  // Перевірка, чи правильно отримано масив
  if (!Array.isArray(services)) {
    console.error("Expected services to be an array but got:", services);
    return <div>Unable to load services</div>; // або інший fallback
  }

  return (
    <section id={styles.homeStatbg} className="staticSection brxeSection">
      <div className={`${styles.serviceMain}`}>
        <div className={styles.bgDarkOverlay}></div>
        <div className={styles.gradOverlayTop}></div>
        <div className={`${styles.serviceBlock} container sideP88`}>
          <div className={styles.leftBlock}></div>
          <div className={styles.rightBlock}>
            {services.map((service, index) => (
              <div
                key={service.id}
                className={`${styles.serviceItem} ${
                  index !== 0 ? "top12" : ""
                }`}
              >
                <p className={styles.idBlock}>{service.id}.</p>
                <div className={styles.infoDescription}>
                  <h5>{service.title}</h5>
                  <p className="textBasic">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.gradOverlayBot}></div>
      </div>
    </section>
  );
};

export default ServiceBlock;
